import axios from '~/utils/axios';
import { urlWithParams } from '~/utils';
import { Batch, BatchFilters } from '~/types/Batch';

export type Response = { cursors: { next?: string }; payrolls: Batch[] };

export const getBatches = (params: BatchFilters): Promise<{ data: Response }> => {
  return axios.get<Response>(urlWithParams('/batches', params));
};

export const getBatch = (id: string): Promise<{ data: Batch }> => {
  return axios.get<Batch>(`/batches/${id}`);
};
